import type { DeployEnvironment } from "@enrein/shared-contracts/deploy-env";
import { deployEnvBannerCopy } from "@enrein/shared-contracts/deploy-env";

export function EnvBanner({ deployEnv }: { readonly deployEnv: DeployEnvironment }) {
  const copy = deployEnvBannerCopy(deployEnv);
  if (!copy) {
    return null;
  }
  return (
    <div className="enrein-env-banner" role="status" aria-live="polite">
      <strong>{copy.headline}</strong>
      <span>{copy.detail}</span>
    </div>
  );
}
